let Category = [
  {
    name: "women's Fashion",
    subcategory: [
      {
        name: "clothing",
      },
      {
        name: "winter Special",
      },
      {
        name: "Muslim wear",
      },
    ],
  },
  {
    name: "Halthe an Beauty",
    subcategory: [
      {
        name: "Shoes",
      },
      {
        name: "watch",
      },
      {
        name: "Bags",
      },
    ],
  },
  {
    name: "women's Fashion 2",
    subcategory: [
      {
        name: "clothing 2",
      },
      {
        name: "winter Special 2",
      },
      {
        name: "Muslim wear 2",
      },
    ],
  },
  {
    name: "Halthe an Beauty 2",
    subcategory: [
      {
        name: "Shoes 2",
      },
      {
        name: "watch 2",
      },
      {
        name: "Bags 2",
      },
    ],
  },
];

let colors = [
  {
    name: "red",
    code: "red",
  },
  {
    name: "green",
    code: "green",
  },
  {
    name: "blue",
    code: "blue",
  },
];
let brands = [
  {
    name: "Brand 1",
  },
  {
    name: "Brand 2",
  },
  {
    name: "Brand 3",
  },
];
let Prices = [
  {
    name: "$0.00 - $9.99",
  },
  {
    name: "$10.00 - $19.99",
  },
  {
    name: "$20.00 - $29.99",
  },
];

export { Category, colors, brands, Prices };
